import type { Locale } from '@change-corgi/config/locales';
import { getFallbackLocale, isSupportedLocale } from '@change-corgi/config/locales';
import type { I18n, Translations } from '@change-corgi/core/i18n';
import { createI18n } from '@change-corgi/core/i18n';
import type { Utilities } from '@change-corgi/core/react/utilityContext';

import { getCountries } from 'src/shared/i18n';

import type { TranslationsOptions } from './getTranslations';
import { getTranslations } from './getTranslations';

function getSupportedLocale(locale: string): Locale {
	if (isSupportedLocale(locale)) {
		return locale;
	}

	return getFallbackLocale();
}

export async function setupI18n(
	utilities: Pick<Utilities, 'http' | 'errorReporter'>,
	{
		translations: translationsP,
		...context
	}: {
		/**
		 * translations to use as a priority, generally coming from hydration data
		 */
		translations?: Translations;
	} & TranslationsOptions,
): Promise<I18n> {
	const locale = getSupportedLocale(context.locale);
	const [translations, { i18nCountries: countries }] = await Promise.all([
		getTranslations(utilities, context),
		getCountries(locale),
	]);

	const i18n = createI18n({
		locale,
		translations: translationsP ? [translationsP, translations] : translations,
		countries,
		reportError: utilities.errorReporter.report.bind(utilities.errorReporter),
	});

	return i18n;
}
